import axios from 'axios';

// let base = 'http://192.168.1.90:8081';
let base = 'http://yun.bjsdzk.com:8081';

axios.defaults.withCredentials = true;

// axios.defaults.headers.common['Authorization'] = 'foo bar';

var token = sessionStorage.getItem('token');
if (!!token) {
  axios.defaults.headers.common['Authorization'] = token;
}

export const auth = params => {
  return axios
    .post(`${base}/user/login`, params)
    .then(res => res.data);
};
export const getMeInfo = (params) => {
  return axios
    .get(`${base}/user/me`, params)
    .then(res => res.data);
};

// 城市API
export const getCityList = (params) => {
  return axios
    .get(`${base}/city`, {params: params})
    .then(res => res.data);
};
export const addCityPrice = (params) => {
  return axios
    .post(`${base}/city`, params)
    .then(res => res.data);
};
export const editCityPrice = (params) => {
  return axios
    .put(`${base}/city`, params)
    .then(res => res.data);
};
export const removeCityPrice = (id) => {
  return axios
    .delete(`${base}/city/` + id)
    .then(res => res.data);
};

// 用户API
export const getUserList = (params) => {
  return axios
    .get(`${base}/user`, {params: params})
    .then(res => res.data);
};
export const getUsersList = (params) => {
  return axios
    .get(`${base}/user/list`, {params: params})
    .then(res => res.data);
};
export const addUser = (params) => {
  return axios
    .post(`${base}/user`, params)
    .then(res => res.data);
};
export const editUser = (params) => {
  return axios
    .put(`${base}/user`, params)
    .then(res => res.data);
};
export const removeUser = (id) => {
  return axios
    .delete(`${base}/user/` + id)
    .then(res => res.data);
};
export const kickUser = (params) => {
  return axios
    .get(`${base}/app/kick`, {params: params})
    .then(res => res.data);
};

// 用户组API
export const getRoleList = (params) => {
  return axios
    .get(`${base}/role`, {params: params})
    .then(res => res.data);
};

// 企业分组API
export const getGroupList = (params) => {
  return axios
    .get(`${base}/device/group`, {params: params})
    .then(res => res.data);
};
export const addGroup = (params) => {
  return axios
    .post(`${base}/device/group`, params)
    .then(res => res.data);
};
export const editGroup = (params) => {
  return axios
    .put(`${base}/device/group`, params)
    .then(res => res.data);
};
export const removeGroup = (id) => {
  return axios
    .delete(`${base}/device/group/` + id)
    .then(res => res.data);
};
export const checkUser = (username) => {
  return axios
    .get(`${base}/user/check/` + username)
    .then(res => res.data);
};

// 企业API
export const getCompanyList = (params) => {
  return axios
    .get(`${base}/company`, {params: params})
    .then(res => res.data);
};
export const getCompanyGroupByCity = (params) => {
  console.log(params);
  return axios
    .get(`${base}/company/groups`, {params: params})
    .then(res => res.data);
};
export const getCompanyStatistic = (params) => {
  return axios
    .get(`${base}/company/allStatistic`, {params: params})
    .then(res => res.data);
};
export const addCompany = (params) => {
  return axios
    .post(`${base}/company`, params)
    .then(res => res.data);
};
export const editCompany = (params) => {
  return axios
    .put(`${base}/company`, params)
    .then(res => res.data);
};
export const removeCompany = (id) => {
  return axios
    .delete(`${base}/company/` + id)
    .then(res => res.data);
};

// 设备API
export const getDevicesList = (params) => {
  return axios
    .get(`${base}/device`, {params: params})
    .then(res => res.data);
};
export const getDevicesinfo = (params) => {
  return axios
    .get(`${base}/device/admin`, {params})
    .then(res => res.data);
};
export const getDevicesByGroupList = (params) => {
  return axios
    .get(`${base}/device/bygroup`, {params: params})
    .then(res => res.data);
};
export const getReportList = (params) => {
  return axios
    .get(`${base}/device/report`, {params: params})
    .then(res => res.data);
};
export const addDevice = (params) => {
  return axios
    .post(`${base}/device`, params)
    .then(res => res.data);
};
export const editDevice = (params) => {
  return axios
    .put(`${base}/device`, params)
    .then(res => res.data);
};
export const removeDevice = (id) => {
  return axios
    .delete(`${base}/device/` + id)
    .then(res => res.data);
};
export const processOff = (id) => {
  return axios
    .put(`${base}/device/off?id=` + id)
    .then(res => res.data);
};
export const processOn = (id) => {
  return axios
    .put(`${base}/device/on?id=` + id)
    .then(res => res.data);
};

// 采集平台参数API
export const getCollectors = (id) => {
  return axios
    .get(`${base}/collector/params/` + id)
    .then(res => res.data);
};
export const saveParams = (params) => {
  return axios
    .put(`${base}/collector/params`, params)
    .then(res => res.data);
};

// 历史数据
export const getDataList = (params) => {
  return axios
    .get(`${base}/device/datas`, {params: params})
    .then(res => res.data);
};
export const getRealtimeDataList = (params) => {
  return axios
    .get(`${base}/device/realtime-datas`, {params: params})
    .then(res => res.data);
};
export const getCurDataList = (params) => {
  return axios
    .get(`${base}/device/cur-datas`, {params: params})
    .then(res => res.data);
};
export const getVolDataList = (params) => {
  return axios
    .get(`${base}/device/vol-datas`, {params: params})
    .then(res => res.data);
};
export const getEnergyDataList = (params) => {
  return axios
    .get(`${base}/device/energy-datas`, {params: params})
    .then(res => res.data);
};
export const getDianliangDataList = (params) => {
  return axios
    .get(`${base}/device/dianliang-datas`, {params: params})
    .then(res => res.data);
};
export const getFuheDataList = (params) => {
  return axios
    .get(`${base}/device/fuhe-datas`, {params: params})
    .then(res => res.data);
};
export const getFuhelvDataList = (params) => {
  return axios
    .get(`${base}/device/fuhelv-datas`, {params: params})
    .then(res => res.data);
};
export const getDianliDataList = (params) => {
  return axios
    .get(`${base}/device/dianli-datas`, {params: params})
    .then(res => res.data);
};
export const getChartDataList = (params) => {
  return axios
    .get(`${base}/device/chart-data`, {params: params})
    .then(res => res.data);
};
export const getWeekDataList = (params) => {
  return axios
    .get(`${base}/device/week-data`, {params: params})
    .then(res => res.data);
};

// 变量API
export const getDeviceParamList = (params) => {
  return axios
    .get(`${base}/device/params`, {params: params})
    .then(res => res.data);
};
export const addDeviceParams = (params) => {
  return axios
    .post(`${base}/device/params`, params)
    .then(res => res.data);
};
export const removeDeviceParams = (id) => {
  return axios
    .delete(`${base}/device/params/` + id)
    .then(res => res.data);
};

// 事件API
export const getEventList = (params) => {
  return axios
    .get(`${base}/exceptions`, {params: params})
    .then(res => res.data);
};
export const editState = (id) => {
  return axios
    .put(`${base}/exceptions/disposed?id=` + id)
    .then(res => res.data);
};
export const processSilent = (id) => {
  return axios
    .put(`${base}/exceptions/silent?id=` + id)
    .then(res => res.data);
};

// 系统通知API
export const getMessageList = (params) => {
  return axios
    .get(`${base}/message`, {params: params})
    .then(res => res.data);
};
export const addMessage = (params) => {
  return axios
    .post(`${base}/message`, params)
    .then(res => res.data);
};
export const editMessage = (params) => {
  return axios
    .put(`${base}/message`, params)
    .then(res => res.data);
};
export const removeMessage = (id) => {
  return axios
    .delete(`${base}/message/` + id)
    .then(res => res.data);
};
export const read = (params) => {
  return axios
    .put(`${base}/message/read`, params)
    .then(res => res.data);
};
export const getUnread = (params) => {
  return axios
    .get(`${base}/message/unread`, params)
    .then(res => res.data);
};

// dashboard
export const getDashboardInfo = (params) => {
  return axios
    .get(`${base}/company/dashboard`, {params: params})
    .then(res => res.data);
};

// dtu API export const getDtuList = (params) => { return
// axios.get(`${base}/dtu`, {params:params}).then(res => res.data); }; export
// const addDtu = (params) => { return axios.post(`${base}/dtu`,
// params).then(res => res.data); }; export const editDtu = (params) => { return
// axios.put(`${base}/dtu`, params).then(res => res.data); }; export const
// removeDtu = (id) => { return axios.delete(`${base}/dtu/` + id).then(res =>
// res.data); }; 能效API
export const getEnergyPriceList = (params) => {
  return axios
    .get(`${base}/energy/price`, {params: params})
    .then(res => res.data);
};
export const addEnergyPrice = (params) => {
  return axios
    .post(`${base}/energy/price`, params)
    .then(res => res.data);
};
export const editEnergyPrice = (params) => {
  return axios
    .put(`${base}/energy/price`, params)
    .then(res => res.data);
};
export const removeEnergyPrice = (id) => {
  return axios
    .delete(`${base}/energy/price/` + id)
    .then(res => res.data);
};

export const getEnergyLevelList = (params) => {
  return axios
    .get(`${base}/energy/level`, {params: params})
    .then(res => res.data);
};
export const addEnergyLevel = (params) => {
  return axios
    .post(`${base}/energy/level`, params)
    .then(res => res.data);
};
export const editEnergyLevel = (params) => {
  return axios
    .put(`${base}/energy/level`, params)
    .then(res => res.data);
};
export const removeEnergyLevel = (id) => {
  return axios
    .delete(`${base}/energy/level/` + id)
    .then(res => res.data);
};

export const getDeviceLogList = (params) => {
  return axios
    .get(`${base}/app/statusLog`, {params: params})
    .then(res => res.data);
};

// 客服API
export const getServiceLogList = (params) => {
  return axios
    .get(`${base}/servicelog`, {params: params})
    .then(res => res.data);
};
export const addServiceLog = (params) => {
  return axios
    .post(`${base}/servicelog`, params)
    .then(res => res.data);
};

export const startDevice = (params) => {
  return axios
    .post(`${base}/device/start`, params)
    .then(res => res.data);
};
export const stopDevice = (params) => {
  return axios
    .post(`${base}/device/stop`, params)
    .then(res => res.data);
};

export const getDeviceAliasList = (params) => {
  return axios
    .get(`${base}/channel/settings`, {params: params})
    .then(res => res.data);
};



// 诊断报告 中性线
export const getneutralLineList = (params) => {
  return axios
    .get(`${base}/report/detail-lx`, {params})
    .then(res => res.data);
}

// 电流 / 温度
export const getCurrentWithTem = (params) => {
  return axios
    .get(`${base}/report/detail-ct`, {params})
    .then(res => res.data);
}

// 谐波
export const getHarmonicList = (params) => {
  return axios
    .get(`${base}/report/detail-xb`, {params})
    .then(res => res.data);
}

// /report/safe
export const getTopList = (params) => {
  return axios.get(`${base}/report/safe`, {params})
    .then(res => res.data);
}

//  /report/power
export const getBottomList = (params) => {
  return axios.get(`${base}/report/power`, {params})
    .then(res => res.data);
}


// WEBPACK FOOTER //
// ./src/api/api.js